// @ts-nocheck


import React from 'react';

import {
  Filter,
  FilterContainer,
  FilterItem,
  Selects,
  FilterButtonsContainer } from
'./../../../../../../../components';

import Field from './../../../../../../../components/card/Field';

const { VehicleModelSelect, VehicleSelect, YearSelect } = Selects;













export default ({ filter, cleanFilter, applyFilter }) =>
<FilterContainer style={{ marginBottom: '16px' }}>
    <Filter
    cleanFilter={cleanFilter}
    applyFilter={applyFilter}
    initialValues={filter}>

      {({
      values,
      changeValue,
      applyFilter,
      cleanFilter
    }) =>
    <>
          <FilterItem>
            <Field mBottomNone>
              <VehicleModelSelect
            placeholder="Все модели ТС"
            size="small"
            value={values['vehicle.vehicleModel.id']}
            onChange={(value) =>
            changeValue('vehicle.vehicleModel.id', value)
            } />

            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <VehicleSelect
            placeholder="Все ТС"
            size="small"
            value={values['vehicle.id']}
            onChange={(value) => changeValue('vehicle.id', value)} />

            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <YearSelect
            placeholder="Год"
            size="small"
            value={values['vehicle.yearIssued']}
            onChange={(value) => changeValue('vehicle.yearIssued', value)} />

            </Field>
          </FilterItem>

          <FilterButtonsContainer
        applyFilter={applyFilter}
        cleanFilter={cleanFilter} />

        </>
    }
    </Filter>
  </FilterContainer>;
